import { jsx, jsxs } from "react/jsx-runtime";
import external_react_default, { memo } from "react";
import { Divider } from "../../Divider/index.js";
import external_ChildAgeSelect_js_default from "./ChildAgeSelect.js";
import { TravelerLineItem } from "./TravelerLineItem.js";
const ChildrenLineItem = ({ ages, ageSelectEnabled, count, max, isHotel, onAgeChange, onChange, subLabel })=>{
    const selects = Array(count).fill(0);
    const sublabel = ageSelectEnabled ? void 0 : subLabel;
    return /*#__PURE__*/ jsxs("div", {
        className: "flex w-full flex-col",
        children: [
            /*#__PURE__*/ jsx(TravelerLineItem, {
                label: "Children",
                subLabel: sublabel,
                min: 0,
                max: max,
                count: count,
                onChange: onChange
            }),
            ageSelectEnabled ? selects.map((_value, index)=>/*#__PURE__*/ jsxs(external_react_default.Fragment, {
                    children: [
                        /*#__PURE__*/ jsx(external_ChildAgeSelect_js_default, {
                            index: index,
                            isHotel: isHotel,
                            value: ages?.[index],
                            onChange: onAgeChange
                        }),
                        index !== selects.length - 1 && /*#__PURE__*/ jsx(Divider, {})
                    ]
                }, `container-${index}`)) : null
        ]
    });
};
const TravelerLineItems_ChildrenLineItem = /*#__PURE__*/ memo(ChildrenLineItem);
export { TravelerLineItems_ChildrenLineItem as default };
